// extracted by mini-css-extract-plugin
module.exports = {"previewMaibSubtitle":"PreviewMain_previewMaibSubtitle__21bbE","previewMainBtn":"PreviewMain_previewMainBtn__38RJz"};